export default "__VITE_ASSET__e492c2fd__"